module.exports = __webpack_public_path__ + "img/volvo-penta-white.f572775f.svg";